import React, {useEffect} from 'react';
import {Text, View} from 'react-native';
import VehicleIcon from '../vehicle-icon/VehicleIcon.component';
import styles from './VehicleCard.style';

export default function VehicleCard(props) {
  const {item, children, leftChildren, hasIcon, containerStyle} = props;
  
  return (
    <View style={[styles.container, containerStyle]}>
      {leftChildren}
      <View style={[styles.infoWrapper, hasIcon && {paddingRight: 8}]}>
        {/* <Text style={styles.name}>{item?.name}</Text> */}
        {children}
      </View>
      {hasIcon && (
        <VehicleIcon VehicleBrand={item?.VehicleBrand || item?.Brand} />
      )}
    </View>
  );
}
